/* ADS cart drawer — glue between the theme's cart events and sections/ads_cart_drawer.liquid.
 *
 * The theme (theme.js, pdp-golden-v1.js, ads-sig5-buy.js, wavell-custom.js, global-gift-validation.js,
 * addon_bundle_remove …) still asks for the OLD section "cart-drawer" and then either dispatches `cart:change`
 * or calls `document.querySelector('cart-drawer')._onCartChanged(event)` directly. We keep the theme's
 * <cart-drawer id="cart-drawer"> element (open/close, overlay, opens on variant:add) and only swap how it
 * re-renders: every cart change re-renders THIS section (id ads_cart_drawer) from the server.
 */
(function () {
  'use strict';
  if (window.__adsCartDrawer) return;
  window.__adsCartDrawer = true;

  var SECTION = 'ads_cart_drawer';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var termsAccepted = false;
  var renderSeq = 0;
  var busy = false;

  function drawer() { return document.querySelector('cart-drawer.ads-cd'); }
  function content() { return document.getElementById('AdsCartDrawer'); }

  function setBusy(on) {
    busy = on;
    var c = content();
    if (c) c.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  function applyHtml(html) {
    if (!html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.getElementById('AdsCartDrawer');
    var cur = content();
    if (!next || !cur) return false;
    var body = cur.querySelector('.adc-body');
    var scroll = body ? body.scrollTop : 0;
    cur.replaceChildren.apply(cur, Array.prototype.slice.call(next.childNodes));
    cur.setAttribute('data-count', next.getAttribute('data-count') || '0');
    cur.removeAttribute('aria-busy');
    var nb = cur.querySelector('.adc-body');
    if (nb && scroll) nb.scrollTop = scroll;
    var t = cur.querySelector('[data-adc-terms]');
    if (t) t.checked = termsAccepted;
    sweepOrphanGifts();
    return true;
  }

  // A gift line (_free_gift / _global_free_gift) that is no longer free means its qualifying product left the
  // cart (e.g. Travel Case after removing the 5 Signature while other paid items stay). Remove it so the
  // customer never pays for a "gift". Each key is tried once per page view to rule out loops.
  var sweptKeys = {};
  function sweepOrphanGifts() {
    var c = content();
    if (!c) return;
    if (busy) { setTimeout(sweepOrphanGifts, 400); return; }
    var updates = {}; var n = 0;
    c.querySelectorAll('.adc-line[data-orphan-gift]').forEach(function (li) {
      var k = li.getAttribute('data-key');
      if (sweptKeys[k]) return;
      sweptKeys[k] = true; updates[k] = 0; n++;
    });
    if (n) setTimeout(function () { updateLines(updates); }, 0);
  }

  // Re-render from the server. Latest call wins, so fast clicks never paint an older cart.
  function refresh(sectionsJson) {
    var seq = ++renderSeq;
    if (sectionsJson && sectionsJson[SECTION]) {
      applyHtml(sectionsJson[SECTION]);
      return Promise.resolve();
    }
    return fetch(root + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (seq === renderSeq && data) applyHtml(data[SECTION]); })
      .catch(function (e) { console.warn('[ads-cart-drawer] refresh failed', e); });
  }

  function onCartEvent(event) {
    var cart = event && event.detail && event.detail.cart;
    return refresh(cart && cart.sections);
  }

  // Take over the theme CartDrawer's re-render hooks on our element (keeps open/close/variant:add untouched).
  function wire(el) {
    if (!el || el.__adsWired) return;
    el.__adsWired = true;
    if (el._onCartChangedListener) document.removeEventListener('cart:change', el._onCartChangedListener);
    if (el._onCartRefreshListener) document.removeEventListener('cart:refresh', el._onCartRefreshListener);
    el._onCartChanged = onCartEvent;
    el._onCartRefresh = function () { return refresh(); };
    el._onCartChangedListener = el._onCartChanged;
    el._onCartRefreshListener = el._onCartRefresh;
    document.addEventListener('cart:change', el._onCartChangedListener);
    document.addEventListener('cart:refresh', el._onCartRefreshListener);
  }

  function init() {
    var el = drawer();
    if (!el) return;
    sweepOrphanGifts();
    if (window.customElements && customElements.get('cart-drawer')) wire(el);
    else if (window.customElements) customElements.whenDefined('cart-drawer').then(function () { wire(drawer()); });
  }

  // Dispatch the same events the theme uses so header counts, gift validator etc. stay in sync.
  function announce(cart, baseEvent) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: baseEvent || 'line-item:change', cart: cart }
    }));
  }

  function postJson(url, body) {
    return fetch(root + url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error((j && (j.description || j.message)) || 'Cart request failed');
        return j;
      });
    });
  }

  function updateLines(updates) {
    setBusy(true);
    return postJson('cart/update.js', { updates: updates, sections: [SECTION] })
      .then(function (cart) { announce(cart, 'line-item:change'); })
      .catch(function (e) { console.error(e); refresh(); })
      .finally(function () { setBusy(false); });
  }

  function addVariant(id) {
    setBusy(true);
    return postJson('cart/add.js', { items: [{ id: Number(id), quantity: 1 }], sections: [SECTION] })
      .then(function (added) {
        return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
          cart.sections = added.sections || {};
          announce(cart, 'variant:add');
        });
      })
      .catch(function (e) { console.error(e); alert(e.message || 'Kunne ikke tilføje produktet.'); refresh(); })
      .finally(function () { setBusy(false); });
  }

  // Lines that must change together: same _addon_bundle_id (bound gifts) or legacy _bundle.
  function groupKeys(li) {
    var keys = [li.getAttribute('data-key')];
    var b = li.getAttribute('data-bundle');
    var lb = li.getAttribute('data-legacy-bundle');
    var c = content();
    if (c && (b || lb)) {
      c.querySelectorAll('.adc-line').forEach(function (o) {
        if (o === li) return;
        if ((b && o.getAttribute('data-bundle') === b) || (lb && o.getAttribute('data-legacy-bundle') === lb)) keys.push(o.getAttribute('data-key'));
      });
    }
    return keys;
  }

  document.addEventListener('click', function (e) {
    var c = content();
    if (!c || !c.contains(e.target)) return;
    if (busy) { if (e.target.closest('button')) e.preventDefault(); return; }

    var q = e.target.closest('[data-adc-qty]');
    var rm = e.target.closest('[data-adc-remove]');
    if (q || rm) {
      e.preventDefault();
      var li = (q || rm).closest('.adc-line');
      if (!li) return;
      var cur = parseInt(li.getAttribute('data-qty'), 10) || 1;
      var max = parseInt(li.getAttribute('data-max'), 10) || 99;
      var next = rm ? 0 : Math.min(max, Math.max(0, cur + parseInt(q.getAttribute('data-adc-qty'), 10)));
      if (next === cur) return;
      // One row that Shopify keeps as several lines (data-split = "key:qty|key:qty"): + adds one unit of the variant,
      // − takes one off the last line, Fjern empties them all.
      var split = li.getAttribute('data-split');
      if (split) {
        var parts = split.split('|').map(function (p) { var i = p.lastIndexOf(':'); return { key: p.slice(0, i), qty: parseInt(p.slice(i + 1), 10) || 0 }; });
        if (next > cur) { addVariant(li.getAttribute('data-variant')); return; }
        var su = {};
        if (next === 0) parts.forEach(function (p) { su[p.key] = 0; });
        else { var last = parts[parts.length - 1]; su[last.key] = last.qty - 1; }
        updateLines(su);
        return;
      }
      var updates = {};
      groupKeys(li).forEach(function (k) { updates[k] = next; });
      updateLines(updates);
      return;
    }

    var add = e.target.closest('[data-adc-add]');
    if (add) {
      e.preventDefault();
      addVariant(add.getAttribute('data-adc-add'));
    }
  });

  document.addEventListener('change', function (e) {
    var c = content();
    if (!c || !c.contains(e.target)) return;

    if (e.target.matches('[data-adc-terms]')) {
      termsAccepted = e.target.checked;
      var err = c.querySelector('.adc-terms__err');
      if (err && termsAccepted) err.hidden = true;
      return;
    }

    if (e.target.matches('[data-adc-optin]')) {
      var box = e.target;
      var row = box.closest('.adc-optin');
      if (row) row.classList.toggle('is-on', box.checked);
      if (box.checked) {
        addVariant(box.getAttribute('data-variant-id'));
      } else {
        // Remove every paid line of the opt-in product
        var pid = String(box.getAttribute('data-product-id'));
        setBusy(true);
        fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
          var updates = {};
          (cart.items || []).forEach(function (it) {
            var p = it.properties || {};
            if (String(it.product_id) === pid && !p._free_gift && !p._global_free_gift && !p._gift_requires) updates[it.key] = 0;
          });
          setBusy(false);
          if (Object.keys(updates).length) updateLines(updates); else refresh();
        }).catch(function () { setBusy(false); refresh(); });
      }
    }
  });

  // Terms must be accepted before checkout. Runs before the theme's own (alert-based) check, which stays as backup.
  window.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'cart-drawer-checkout-form' || !form.closest('.ads-cd')) return;
    var t = form.querySelector('[data-adc-terms]');
    if (t && t.checked) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var label = form.querySelector('.adc-terms');
    var err = form.querySelector('.adc-terms__err');
    if (err) err.hidden = false;
    if (label) {
      label.classList.remove('is-nudge');
      void label.offsetWidth;
      label.classList.add('is-nudge');
      setTimeout(function () { label.classList.remove('is-nudge'); }, 600);
    }
    if (t) t.focus();
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
